import React from "react";
import {
    Tree
} from 'antd';
import { Link, withRouter } from 'react-router-dom';
import { ReadOutlined } from '@ant-design/icons';

import './index.less';

const {
    TreeNode,
    DirectoryTree
} = Tree;

class LeftNav extends React.Component{
    state = {
        loading: true,
        menu_list: this.props.menu_list,
        classifies: this.props.classifies,
        articles: this.props.articles,
        selectedKeys: []
    };
    openKeys = [];

    showMenuList = (menuList) => {
        return menuList.map((item, index) => {
            if(!item.children) {
                if(item.title) { // 文章
                    return (
                        <TreeNode icon={<ReadOutlined />} title={<Link to={`/repository/article/detail/${item.id}`}>{item.title}</Link>} key={'article_' + item.id} />
                    );
                }else { // 分类
                    return (
                        <TreeNode title={item.name} key={'classify_' + item.id} />
                    );
                }
            }else {
                return (
                    <TreeNode title={item.name} key={'classify_' + item.id}>
                        {this.showMenuList(item.children)}
                    </TreeNode>
                );
            }
        });
    }

    getParent = (arr, classify) => {
        const target = arr.find(ele => ele._id === classify);
        if(target) {
            this.openKeys.push('classify_' + target._id);
            if(target.parent_id) {
                this.getParent(arr, target.parent_id);
            }
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        const tmpArr = nextProps.location.pathname.split('/');
        const id = tmpArr[tmpArr.length-1];
        const type = tmpArr[tmpArr.length-2];
        let keys = [];
        if(id && id.length === 24) {
            if(type === 'detail') { //文章
                keys.push('article_' + id);
                if(nextProps.articles) {
                    const article = nextProps.articles.find(ele => ele._id === id);
                    const classifyId = article.classify_id;
                    this.openKeys = [];
                    for(let i = 0; i < classifyId.length; i++) {
                        const classify = classifyId[i];
                        this.openKeys.push('classify_' + classify);
                        this.getParent(nextProps.classifies, classify);
                    }
                }
            } else {
                keys.push('classify_' + id);
                if(nextProps.classifies) {
                    this.openKeys = [];
                    this.openKeys.push('classify_' + id);
                    this.getParent(nextProps.classifies, id);
                }
            }
        }
        this.setState({
            menu_list: nextProps.menu_list,
            selectedKeys: keys
        });
    }

    render() {
        return (
            <DirectoryTree
                //defaultExpandAll
                //selectable={false}
                selectedKeys={this.state.selectedKeys}
                expandedKeys={this.openKeys}
                onSelect={(key, e) => {
                    const type = key[0].split('_')[0];
                    if(type === 'classify') {
                        const id = key[0].split('_')[1];
                        this.props.history.push('/repository/catalogue/' + id);
                    }
                }}
            >
                {this.showMenuList(this.state.menu_list)}
            </DirectoryTree>
        );
    }
}

export default withRouter(LeftNav);